var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasLoaded)?_c('Multiple',{attrs:{"body":_vm.questionBody,"disabled":_vm.buttonDisabled},on:{"submitAnswer":_vm.submitAnswer}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }